$(document).ready(function() {
    var tempValue = '';
    $('#duedate').on('change', function() {

        resetTable();

        var rushDate = $(this).val();

        // keep the prompt from showing up over and over and over and over. only show prompt when date actually changes.
        if(rushDate == tempValue || rushDate == '') {
            if(rushDate == ''){
                $(this).removeClass('caution');
                $('#rushNotice').addClass('hidden');
                $('#acceptRush').attr('disabled','disabled');
                tempValue = '';
            }
            return;
        } else {
            tempValue = rushDate;
            $(this).addClass('caution');
        }

        var date            = moment(rushDate).format('LL');
        var numDate         = moment(rushDate).format('L');
        var oneday          = getLeadDayByRushDate(rushDate, 1);
        var twoday          = getLeadDayByRushDate(rushDate, 2);
        var threeday        = getLeadDayByRushDate(rushDate, 3);
        var fiveday         = getLeadDayByRushDate(rushDate, 5);
        var now             = new Date();
        var nowDayFormat    = new Date().toLocaleDateString('en-us', {month:"numeric", day:"numeric", year:"numeric"});
        var fiveDate        = new Date(fiveday);
        var threeDate       = new Date(threeday);
        var twoDate         = new Date(twoday);
        var oneDate         = new Date(oneday);

        now.setHours(0,0,0,0);

        if(fiveDate < now && threeDate < now)
            $('#newRushLevelOne').hide();
        else{
            if(fiveDate < now)
                if(nowDayFormat === threeday){
                    $('#threeToFiveRush').hide();
                    $('#fiveLeadEqualsThreeLead').text(nowDayFormat);
                    $('#fiveLeadEqualsThreeData').show();
                }
                else
                    $('#fiveDayLead').text(nowDayFormat);
            else
                $('#fiveDayLead').text(fiveday);

            $('#threeDayLead').text(threeday);
            $('#newRushLevelOne').show();
        }

        if(twoDate < now && oneDate < now)
            $('#newRushLevelTwo').hide();
        else{
            if(twoDate < now)
                if(nowDayFormat === oneday){
                    $('#twoToOneRush').hide();
                    $('#twoLeadEqualsOneLead').text(nowDayFormat);
                    $('#twoLeadEqualsOneData').show();
                }
                else
                    $('#twoDayLead').text(nowDayFormat);
            else
                $('#twoDayLead').text(twoday);

            $('#oneDayLead').text(oneday);
            $('#newRushLevelTwo').show();
        }

        if(twoDate < now)
            $('#oldRushTwoDayData').hide();
        else{
            $('#oldTwoDayLead').text(twoday);
            $('#oldRushTwoDayData').show();
        }

        $('#oldOneDayLead').text(oneday);
        $('#rushdate').text(date);
        $('#rushDater').text(numDate);

        $('#acceptRush').removeAttr('disabled');
        $('#rushNotice').removeClass('hidden');
    });
    $('#duedate').trigger('change');
});

function resetTable(){
    $('#twoToOneRush').show();
    $('#threeToFiveRush').show();
    $('#fiveLeadEqualsThreeData').hide();
    $('#twoLeadEqualsOneData').hide();
}

function getLeadDayByRushDate(rushDate, num){
    var day = moment(rushDate).businessSubtract(num,'days').format('MM/D/YYYY');

    if(day.indexOf(' at') > 0)
        day = day.substring(0, day.indexOf(' at'));

    return day;
}